import app from '../app.first';

app.WorkExperience = class extends app.Component {
    onReady() {
        console.log(this.$el);
        const $noExperienceBox = this.$el.find('[data-no-experience]');

        /**
         * Enforce that only one current job can be had. When one is checked, others become
         * unchecked.
         */
        $(document).on('change', '.current-job', e => {
            if (e.target.checked) {
                this.$el.find('.current-job:checked')
                    .not($(e.target))
                    .prop('checked', false).trigger('change');
            }
        });

        /**
         * If "no experience" is checked, remove all work experience.
         * If it becomes checked, add a work experience item for the user.
         */
        $noExperienceBox.on('change', e => {
            if (e.target.checked) {
                this.$el.find('[data-matrix-container]').empty();
                this.$el.find('[data-add]').addClass('hide');
            } else {
                this.$el.find('[data-add]').click();
                this.$el.find('[data-add]').removeClass('hide');
            }
        });

        /**
         * If item has been added or removed (matrix updated), and we have no more job experience
         * items, check the "no experience" box and trigger the change.
         */
        $(document).on('matrixUpdated', e => {
            if (this.$el.find('[data-matrix-container]').children().length < 1) {
                $noExperienceBox.prop('checked', true).trigger('change');
            }
        });

        /**
         * Automatically uncheck no experience box so users are encouraged to
         * fill out some work experience. Wrapped in timeout to give the matrix
         * component time to initialize the data-add listener
         */
        if ($noExperienceBox.data('no-experience') === null) {
            setTimeout(() => $noExperienceBox.prop('checked', false).trigger('change'), 10);
        }
    }
}